import { Dispatch, SetStateAction } from "react"

import { ComponentContent } from "@tfg/types/schemas/communication-studio/components"

import { DynamicTextEditor } from "~/pages/Brand/CommunicationStudio/Content/DynamicTextEditor"

export const BulletedListRenderer = ({
  textContent,
  setTextContent,
}: {
  textContent: ComponentContent | null
  setTextContent: Dispatch<SetStateAction<ComponentContent>>
}) => {
  return (
    <DynamicTextEditor
      value={textContent ?? {}}
      contentType="list"
      onChange={(content) => {
        setTextContent({
          ...textContent,
          ...content,
        })
      }}
    />
  )
}
